/**
 * Общее число записей справочника вне состава — для окна выбора, которое читает справочник первым окном
 * выдачи. `undefined`, когда окно выдачи вместило всё, что под отбором, и сообщать о неполноте нечего.
 *
 * Записи состава в окне выбора не предлагаются, поэтому из общего числа вычитаются — но только те, что
 * в нём заведомо учтены. Окно с поиском на сервере знает лишь записи состава, попавшие в выдачу: о прочих
 * под тем же запросом ему неизвестно, и вычет записи, которой в общем числе нет, занизил бы его.
 *
 * @param existingInDirectoryCount - Сколько записей состава заведомо учтено в общем числе
 */
export const getOutsideTotal = (total: number | undefined, loadedCount: number, existingInDirectoryCount: number) =>
  total !== undefined && total > loadedCount ? total - existingInDirectoryCount : undefined;
